function animateInView(element){
    const chartProgressBarSelector = '.chart__progressbar__line[data-style]';
    const chartChildren = element.childNodes;
    // let largestNumber = 0;
    // chartChildren.forEach((elem, index) => {
    //     const chartProgressElement = elem.querySelector(chartProgressBarSelector);
    //     largestNumber = Math.max(largestNumber, Number(chartProgressElement.getAttribute("data-value").replace('%', '')));
    // });
    chartChildren.forEach((elem, index) => {
        setTimeout(() => {
            const chartProgressElement = elem.querySelector(chartProgressBarSelector);
            // const styles = chartProgressElement.getAttribute("data-style");
            chartProgressElement.setAttribute('style', chartProgressElement.getAttribute("data-style"))
            // const progressBarNumber = (100 / largestNumber) * Number(progressBarValue.replace('%', ''));
            // chartProgressElement.style.maxWidth = `${progressBarNumber.toString() + '%'}`;

        }, 100 * index);
    });
}


export const chartBar = () => ({
    chart: {
        ['x-inview']() {
            animateInView(this.$el);
        }
    }
});
